var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModalListaDisenadorVacio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 464 472",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d6781c;}.cls-2{fill:#efc7a2;}.cls-3{fill:#edbe93;}.cls-4{fill:#8eb25e;}.cls-5{fill:#ebb584;}.cls-6{fill:#87aa57;}.cls-7{fill:#444e62;}.cls-8{fill:#e2a26b;}.cls-9{fill:#de831f;}.cls-10{fill:#6d452f;}.cls-11{fill:#dededc;}.cls-12{fill:#d4d4d2;}.cls-13{fill:#adadac;}.cls-14{fill:#bdbdbb;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 51zzz") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WEB_VIEW",
    "data-name": "WEB VIEW"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M288,224H408a190.5,190.5,0,0,0,32-105.69V96H256v22.31A190.5,190.5,0,0,0,288,224Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M459.84,278.24A40,40,0,0,0,424,256H384a8,8,0,0,1-8-8V192H312v56a8,8,0,0,1-8,8H256.67a40,40,0,0,0-39.19,32L176,472h55.72l25.41-85.43A60.48,60.48,0,0,0,271.31,424l.58,48H432a32,32,0,0,0,32-32V296a39.68,39.68,0,0,0-4.16-17.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M464,296V440a32,32,0,0,1-32,32H306c51.26-31.94,119.27-91.38,153.84-193.76A39.68,39.68,0,0,1,464,296Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M416,424v48H272l-.69-48c-19.79-23.56-18.46-57.28.69-80V256h24l7.21,25.23a42.42,42.42,0,0,0,81.58,0L392,256h24v88c.66.78,1.3,1.58,1.91,2.39A62.07,62.07,0,0,1,416,424Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M376,224.49V192H312v32.26a68.7,68.7,0,0,0,27.21,7.59A71.82,71.82,0,0,0,376,224.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M416,424v48H293.55c40.91-25.69,88.75-65.74,124.36-125.61A62.07,62.07,0,0,1,416,424Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M376.18,356.65a17,17,0,0,0-22.92,5.1L296,450,301.3,472l22.91-5.1,57.27-88.21a15.65,15.65,0,0,0-4.65-21.64c-.21-.14-.43-.27-.65-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M392,424l-32-16-40,8v56H432a32,32,0,0,0,32-32V416Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M416,80v64a72,72,0,0,1-67.75,71.88,73.69,73.69,0,0,1-9,0c-38.27-2.47-67.21-36-67.21-74.31V80a72,72,0,0,1,144,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M416,80v64a72,72,0,0,1-67.75,71.88A72,72,0,0,0,387,152V64a71.81,71.81,0,0,0-21.09-50.91c-.85-.85-1.71-1.67-2.6-2.47A72,72,0,0,1,416,80Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M344,176a24,24,0,0,1-24-24h16a8,8,0,0,0,16,0h16A24,24,0,0,1,344,176Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M440,96v32H416V96a86.33,86.33,0,0,1-26.62-20.66A83.27,83.27,0,0,1,384,68.45a86.2,86.2,0,0,1-11.31-22.39L368,32,352,83.26A121.61,121.61,0,0,1,248,168V96a96,96,0,0,1,192,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M380,128a12,12,0,1,1,12-12A12,12,0,0,1,380,128Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M440,96v32H416V96a86.33,86.33,0,0,1-26.62-20.66A83.27,83.27,0,0,1,384,68.45V48A71.63,71.63,0,0,0,368.28,3.1,96.08,96.08,0,0,1,440,96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M416,96h8a24,24,0,0,1,0,48h-8V96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M272,240V384a24,24,0,0,1-24,24H23.53A24,24,0,0,1,0,384V240a24,24,0,0,1,24-24H248A24,24,0,0,1,272,240Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M272,240V384a24,24,0,0,1-24,24H23.53c68.89-28.67,170.2-86.57,223-192H248A24,24,0,0,1,272,240Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M104,440h96v32H104Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M152,472H72l32-128h64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M24,240H56v16H24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M72,240h32v16H72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M120,240h32v16H120Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M168,240h32v16H168Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M216,240h32v16H216Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalListaDisenadorVacio);
export default __webpack_public_path__ + "static/media/modal-lista-disenador-vacio.4eabb8f830ae2569c620bf09e841ec41.svg";
export { ForwardRef as ReactComponent };